import { KubernetesSecurityFormValues } from './types';
import { SecuritySection } from './SecuritySection';
import { PodSecurityConstraintsSection } from './PodSecurityConstraintsSection';
import { ConstraintsSection } from './ConstraintsSection';

interface Props {
  formData: KubernetesSecurityFormValues;
  onChange: <K extends keyof KubernetesSecurityFormValues>(
    key: K,
    value: KubernetesSecurityFormValues[K]
  ) => void;
}

export function KubernetesSecurityFormFields({ formData, onChange }: Props) {
  return (
    <>
      <SecuritySection formData={formData} onChange={onChange} />

      <PodSecurityConstraintsSection formData={formData} onChange={onChange} />

      {formData.enablePodSecurityConstraints && (
        <ConstraintsSection formData={formData} onChange={onChange} />
      )}
    </>
  );
}
